export default "__VITE_ASSET__CQPGF8xr__"